import settingsJson from './settings.json';

export interface Credentials {
  username: string;
  password: string;
}

export interface Settings {
  credentials: Credentials;
  showAlgorithms?: number;
}

const settings: Settings = {
  credentials: settingsJson.credentials || {
    username: 'admin',
    password: 'password123',
  },
  showAlgorithms: settingsJson.showAlgorithms !== undefined ? settingsJson.showAlgorithms : 1,
};

export default settings;

